// @flow

import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';
import SearchInput from 'react-aaui/lib/SearchInput';

import { getPortalPath } from 'modules/app/selector';
import ViewAllLink from 'components/ViewAllLink/ViewAllLink';
import {
  doSearch, endSearch, handleChange, fetchUmbrellaEvent,
} from 'scenes/UmbrellaHome/duck/duck';
import { getKeywords } from 'scenes/UmbrellaHome/duck/selector';

import {
  EVENT_LIMIT,
  OFFSET,
} from 'services/query/query';

import './EventListHeader.scss';

type Props = {
  l10n: L10n,
  total?: number,
  pagination?: boolean,
  onSearch: () => void,
  handleChange: (value: string) => void,
  keywords: string
}

class EventListHeader extends PureComponent<Props> {
  onSearch = (value: string) => {
    const { keywords } = this.props;
    const { portalType, portalId } = this.props.portalPath;

    if (!value) {
      this.props.endSearch();
      this.props.fetchUmbrellaEvent(value, OFFSET, EVENT_LIMIT, portalType, portalId);
    } else {
      this.props.doSearch();
      this.props.fetchUmbrellaEvent(keywords, OFFSET, EVENT_LIMIT, portalType, portalId);
    }
  }

  handleChange = (value: string) => {
    this.props.handleChange(value !== undefined ? value : this.props.keywords);
  }

  render() {
    const { total, pagination } = this.props;
    const { keywords, l10n: { formatMessage } } = this.props;
    return (
      <div className="event-list__title">
        <Row fluid justify="between" align="center">
          <Col md={8} sm={12}>
            <L10nMessage id="page.search.tab.events" />
            <span className="event-list__title-tag">
              {total}
            </span>
            {
              !pagination ? <ViewAllLink onClickViewAll={this.onClickViewAll} /> : null
            }
          </Col>
          <Col md={4} sm={12}>
            <SearchInput
              size="lg"
              className="event-header-bar__search"
              trigger="enter"
              onChange={this.handleChange}
              onSearch={this.onSearch}
              value={keywords}
              placeholder={formatMessage('page.search.events.placeholder')} />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapToState = (state: Map<*, *>) => ({
  portalPath: getPortalPath(state),
  keywords: getKeywords(state),
});
const mapDispatch = dispatch => bindActionCreators({
  doSearch, endSearch, handleChange, fetchUmbrellaEvent,
}, dispatch);

export default connect(mapToState, mapDispatch)(injectL10n()(EventListHeader));
